import type { RouteObject } from 'react-router';

import * as viewEventHorizonRouteExports from '#/modules/listing/events/pages/view/ViewEvent.horizon-route';
import * as viewInternshipHorizonRouteExports from '#/modules/listing/internships/pages/view/ViewInternship.horizon-route';
import * as viewJobHorizonRouteExports from '#/modules/listing/jobs/pages/view/ViewJob.horizon-route';
import * as viewOrgHorizonRouteExports from '#/modules/listing/orgs/pages/view/ViewOrg.horizon-route';
import * as viewVolopHorizonRouteExports from '#/modules/listing/volops/pages/view/ViewVolop.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import {
  viewEventRoutePaths,
  viewInternshipRoutePaths,
  viewJobRoutePaths,
  viewOrgRoutePaths,
  viewVolopRoutePaths,
} from './listing.route-paths';
import {
  viewEventReferenceRoute,
  viewInternshipReferenceRoute,
  viewJobReferenceRoute,
  viewOrgReferenceRoute,
  viewVolopReferenceRoute,
} from './listing.routes';

const viewEventRouteObject = horizonRouteToObject(viewEventHorizonRouteExports);
const viewInternshipRouteObject = horizonRouteToObject(
  viewInternshipHorizonRouteExports,
);
const viewJobRouteObject = horizonRouteToObject(viewJobHorizonRouteExports);
const viewOrgRouteObject = horizonRouteToObject(viewOrgHorizonRouteExports);
const viewVolopRouteObject = horizonRouteToObject(viewVolopHorizonRouteExports);
const createViewJobRouteObject = (path: string): RouteObject => ({
  path: viewJobReferenceRoute.fullPath.replace('/-lang/-segment', path),
  ...viewJobRouteObject,
});
const createViewInternshipRouteObject = (path: string): RouteObject => ({
  path: viewInternshipReferenceRoute.fullPath.replace('/-lang/-segment', path),
  ...viewInternshipRouteObject,
});
const createViewVolopRouteObject = (path: string): RouteObject => ({
  path: viewVolopReferenceRoute.fullPath.replace('/-lang/-segment', path),
  ...viewVolopRouteObject,
});
const createViewEventRouteObject = (path: string): RouteObject => ({
  path: viewEventReferenceRoute.fullPath.replace('/-lang/-segment', path),
  ...viewEventRouteObject,
});
const createViewOrgRouteObject = (path: string): RouteObject => ({
  path: viewOrgReferenceRoute.fullPath.replace('/-lang/-segment', path),
  ...viewOrgRouteObject,
});

export const listingRouteObjects = [
  ...viewJobRoutePaths.map(createViewJobRouteObject),
  ...viewInternshipRoutePaths.map(createViewInternshipRouteObject),
  ...viewVolopRoutePaths.map(createViewVolopRouteObject),
  ...viewEventRoutePaths.map(createViewEventRouteObject),
  ...viewOrgRoutePaths.map(createViewOrgRouteObject),
] satisfies RouteObject[];
